import RangeStyle from '../schema/RangeStyle';
import React from 'react';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { DEFAULT_PIXELS_PER_MINUTE } from 'mini-day-view/lib/utils/constants';
import { OwaDate, endOfDay, startOfDay, today } from 'owa-datetime';
import { mergeStyles } from '@uifabric/merge-styles';
import { getTimestamp } from 'owa-datetime';

const styles = require('./RangeStylistLayer.scss');
const classNames = require('classnames/bind').bind(styles);

export interface RangeStylistLayerProps {
    rangeStyles: RangeStyle[];
    range?: {
        rangeStart: OwaDate;
        rangeEnd: OwaDate;
    };
    pixelsPerMinute?: number;
}

const RangeStylistLayer: (props: RangeStylistLayerProps) => JSX.Element = (
    props: RangeStylistLayerProps
): JSX.Element => {
    const timeOnRender = today();
    const {
        rangeStyles,
        range = {
            rangeStart: startOfDay(timeOnRender),
            rangeEnd: endOfDay(timeOnRender),
        },
        pixelsPerMinute = DEFAULT_PIXELS_PER_MINUTE,
    } = props;

    const layerStartDate: number = getTimestamp(range.rangeStart);

    return (
        <div className={styles.stylistScreen}>
            {rangeStyles.map((rangeStyle, index) => (
                <div
                    key={'rangeStyle_' + index}
                    className={classNames(
                        styles.range,
                        mergeStyles({
                            top:
                                ((rangeStyle.start - layerStartDate) /
                                    TimeConstants.MillisecondsIn1Min) *
                                    pixelsPerMinute +
                                'px',
                            height:
                                ((rangeStyle.end - rangeStyle.start) /
                                    TimeConstants.MillisecondsIn1Min) *
                                    pixelsPerMinute +
                                'px',
                        }),
                        rangeStyle.rangeClassName
                    )}
                />
            ))}
        </div>
    );
};

export default RangeStylistLayer;
